import { Loader2 } from 'lucide-react';

export default function Spinner({
  size = 20,
  label,
  className = '',
}) {
  return (
    <div className={`spinner ${className}`}>
      <Loader2 className="spin" size={size} />
      {label && <span className="spinner__label">{label}</span>}
    </div>
  );
}
